import React, { useEffect } from 'react';
import KidDeviceList from './KidDeviceList';
import CurrentLocation from './CurrentLocation';
import RecentActivity from './RecentActivity';
import {
    kidDevices,
    setKidDevicesList, 
    setDashboardLoader
} from '../../AxiosRtk/DashBoard';
import { useDispatch, useSelector } from 'react-redux';
import { useDashboardDataProvider } from '../../../customHooks/dashboardDataProvider';

const DeviceContainer = () => {
    const dispatch = useDispatch();
    const { handleDeviceSelection } = useDashboardDataProvider();
    const { selectedKidId } = useSelector(({dashboard}) => dashboard);

    useEffect(() => {
        if (selectedKidId) {
            kidDevices(selectedKidId)
                .then((res) => {
                    dispatch(setKidDevicesList(res?.data?.result));
                    // handleDeviceSelection({value: res?.data?.result[0]?.ID ?? null})
                })
                .catch((err) => {
                    console.log("kid devices list catch error ==>>", err?.response?.data?.message)
                })
                .finally(() => {
                    dispatch(setDashboardLoader(false))
                })
        }
    }, [selectedKidId])

    return (
        <>
            <KidDeviceList />
            <CurrentLocation />
            <RecentActivity />
        </>
    )
}

export default DeviceContainer